// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"b4ab610e","1922":"b4ab610e","2899":"b4ab610e","3007":"305cb0f0","3166":"b4ab610e","5291":"b4ab610e","9600":"b4ab610e"}[chunkId] + ".chunk.css";
};